<div style=" display: flex; flex-direction: column;">
  <section class="chart-filters">
    <ng-container *ngIf="instrument?.regionId === 1 && tabType === 'instrument'">
      <span style="margin-left: 10px; color: #23313E; font-weight: bold; margin-right: 10px;">Mode: </span>
      <div (click)="switchMode()"
           statistic
           statisticElementName="Switch time skew chart RT/EOD mode"
           class="chart-switcher">
        <div *ngIf="mode === 'rt_stocks'" [class.active]="!isEOD">RT</div>
        <div *ngIf="mode === 'delayed_stocks'" [class.active]="!isEOD">DELAYED</div>
        <div [class.active]="isEOD">EOD</div>
      </div>

    </ng-container>
    <div
      statistic
      statisticElementName="Click IV CALL on time skew chart"
      (click)="toggleChart('callActive')" [class.active]="callActive" class="inline-button call"
         style="margin-left: auto;">IV CALL
    </div>
    <div
      statistic
      statisticElementName="Click IV PUT on time skew chart"
      (click)="toggleChart('putActive')" [class.active]="putActive" class="inline-button put">IV PUT</div>
  </section>
  <div class="ignore-darkreader" id='{{chartId}}' style="flex: 1;">
    <ng-container *ngIf="noDataAvailable">
      <div class="no-data-available">No data available.</div>
    </ng-container>
  </div>
</div>
